import { httpRequest } from './httpRequest.js';

export const getRequest = ({
  endpoint,
  params = {},
  query = {},
  options = {}
}) => {
  return httpRequest({
    method: 'GET',
    endpoint,
    params,
    query,
    options
  });
};

export const postRequest = ({
  endpoint = '',
  body = {},
  params = {},
  query = {},
  options = {}
}) => {
  return httpRequest({
    method: 'POST',
    endpoint,
    body,
    params,
    query,
    options
  });
};

export const putRequest = ({
  endpoint,
  body = {},
  params = {},
  query = {},
  options = {}
}) => {
  return httpRequest({
    method: 'PUT',
    endpoint,
    body,
    params,
    query,
    options
  });
};

export const patchRequest = ({
  endpoint,
  body = {},
  params = {},
  query = {},
  options = {}
}) => {
  return httpRequest({
    method: 'PATCH',
    endpoint,
    body,
    params,
    query,
    options
  });
};

export const deleteRequest = ({
  endpoint,
  params = {},
  query = {},
  options = {}
}) => {
  return httpRequest({
    method: 'DELETE',
    endpoint,
    params,
    query,
    options
  });
};


